<header id="header">
  <nav class="navbar navbar-light bg-white d-flex">
    <div>
      <div *ngIf="!hideMenu" class="toggle-mobile-menu" (click)="toggleMenu()">
        <div class="line line-1"></div>
        <div class="line line-2"></div>
        <div class="line line-3"></div>
      </div>
      <a class="navbar-brand mb-0 h1" [routerLink]="'/'">
        <span class="amadeus-word">Amadeus</span>
        <span class="direct-word">Direct</span>
      </a>
    </div>
    <div class="quick-access float-end">
      <app-loyalty-widget></app-loyalty-widget>
      <a
        *ngxPermissionsOnly="['CONFIG_CATALOG_ENABLED', 'CONFIG_NEWS_ENABLED']"
        id="search"
        class="df-link-icononly fa-magnifying-glass"
        (click)="toggleSearchPanel()"
        style="margin-left: -5px;"
      >
      </a>
      <a (click)="directLoggedOut()" class="link logout d-none d-sm-inline">
        <span [innerHTML]="logoutString || ''"></span>
      </a>
    </div>
  </nav>
</header>
